let alertFunction = null;

export const registerAlertFunction = (fn) => {
  alertFunction = fn;
};

const triggerNotification = ({ message, type, title, placement = "topRight" }) => {
  if (alertFunction) {
    alertFunction({ message, type, title, placement });
  }
};

export function showServerError(title) {
  triggerNotification({
    message: "Internal Server Error. Please try again later.",
    type: "error",
    title,
  });
}

export function showSuccess(message, title = "", placement = "topRight") {
  triggerNotification({ message, type: "success", title, placement });
}

export function showWarning(message, title = "", placement = "topRight") {
  triggerNotification({ message, type: "warning", title, placement });
}

export function showError(message, title = "", placement = "topRight") {
  triggerNotification({ message, type: "error", title, placement });
}

export function showSessionError(title) {
  triggerNotification({
    message: "Session has expired. Please login again.",
    type: "error",
    title,
  });
}

export function showCustomError(title, message) {
  triggerNotification({ message, type: "error", title });
}
